import en from './en';
import pl from './pl';

export const languageObject = {
    en,
    pl
};